module.exports = __webpack_public_path__ + "static/media/intelligentappmobile.10792970.gif";